define(function (require) {

	//==================================================================================
    //=======================================[ Imports ]================================
    //==================================================================================

	var $ = require("jquery");
	require("bootstrap");


	//====================================================================================
    //=======================================[ Events ]===================================
    //====================================================================================

	//--[ creation stats interne click counter en paralèlle des stats externes ]
	$('ins').find('a').on('click', function () {
		var $root = $(this).parents('.item-inner');
		var $clickCounter = $root.find('.lnkClickCounter');
		if ($clickCounter.length == 0) {
			$.ajax({
				method: 'get',
				url: $root.find('.clickCounter').data('link'),
			}).fail(function (xhr, testStatus) {
				console.log("Une erreur s'est produite durant la création de la stat 'click counter' => " + testStatus);
			});			
		}
	});


	//====================================================================================
    //=======================================[ Initialize ]===============================
    //====================================================================================

});
